export default "__VITE_ASSET__cd690730__"